import { render, staticRenderFns } from "./PatientVotDetails.vue?vue&type=template&id=93dd170e&scoped=true"
import script from "./PatientVotDetails.vue?vue&type=script&lang=js"
export * from "./PatientVotDetails.vue?vue&type=script&lang=js"
import style0 from "./PatientVotDetails.vue?vue&type=style&index=0&id=93dd170e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "93dd170e",
  null
  
)

export default component.exports